/**
 * Utility functions for working with unified highlight system
 */

import { Highlight, HighlightGroup } from '../types/highlight-types';

interface LegacyTaskHighlight {
  text: string;
  taskId: string;
}

/**
 * Convert legacy task highlights to unified Highlight structure
 */
function convertTaskHighlights(
  taskHighlights: LegacyTaskHighlight[],
  keyTaskId?: string
): Highlight[] {
  return taskHighlights.map((task) => ({
    id: `task-${task.taskId}`,
    searchText: task.text,  // Single text to search
    color: '#ffeb3b',
    opacity: 0.7,
    isKeyHighlight: task.taskId === keyTaskId,
    metadata: {
      taskId: task.taskId
    }
  }));
}

/**
 * Build highlight groups from legacy parameters
 */
export function buildHighlightGroups(params: {
  taskHighlights?: LegacyTaskHighlight[];
  keyTaskId?: string;
  showDeadlinesInitially?: boolean;
}): HighlightGroup[] {
  const {
    taskHighlights = [],
    keyTaskId,
    showDeadlinesInitially = false
  } = params;

  const groups: HighlightGroup[] = [];

  // Deadline/task group
  if (taskHighlights.length > 0) {
    groups.push({
      type: 'deadline',
      label: 'Deadlines',
      visible: showDeadlinesInitially,
      highlights: convertTaskHighlights(taskHighlights, keyTaskId)
    });
  }

  return groups;
}

